import { render, staticRenderFns } from "./UnassignedWatermeters.vue?vue&type=template&id=65e25444&scoped=true&"
import script from "./UnassignedWatermeters.vue?vue&type=script&lang=js&"
export * from "./UnassignedWatermeters.vue?vue&type=script&lang=js&"
import style0 from "./UnassignedWatermeters.vue?vue&type=style&index=0&id=65e25444&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e25444",
  null
  
)

export default component.exports